import { useParams } from "react-router-dom";

import { PlantGuest } from "../../../../../api/types/plants";
import { CafsVariable } from "../../../../../types/cafs-variable";
import { createOptions } from "../../../../../utils/create-options";
import { useGuestsData } from "../../../api/useGuestsData";
import { CafsVariableType } from "../../../const/cafs-variable-type";

export function useGuestCreateVariables(): CafsVariable<PlantGuest>[] {
  const { datasetId, id } = useParams();
  const { guests } = useGuestsData(datasetId, id);

  return [
    {
      type: CafsVariableType.Input,
      name: "Name",
      text: true,
      required: true,
    },
    {
      type: CafsVariableType.Select,
      name: "Category",
      options: createOptions(guests?.Categories),
      required: true,
    },
    {
      type: CafsVariableType.Input,
      name: "PressureMaxScale",
    },
    {
      type: CafsVariableType.Input,
      name: "RpMonth",
    },
    {
      type: CafsVariableType.Input,
      name: "InitialMonth",
    },
    {
      type: CafsVariableType.Input,
      name: "DurationMonths",
    },
    {
      type: CafsVariableType.Input,
      name: "RhythmYears",
    },
    {
      type: CafsVariableType.Input,
      name: "ContrToBiodiversity",
    },
    {
      type: CafsVariableType.Input,
      name: "SOMSensitivity",
    },
    {
      type: CafsVariableType.Input,
      name: "OptSOMtpHa",
    },
  ];
}
